import { render } from "./CatScreen.vue?vue&type=template&id=07ab777a&scoped=true"
import script from "./CatScreen.vue?vue&type=script&lang=js"
export * from "./CatScreen.vue?vue&type=script&lang=js"

import "./CatScreen.vue?vue&type=style&index=0&id=07ab777a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ab777a"]])

export default __exports__